export default __webpack_public_path__ + "static/Group 348-a14317b18b5aaac12b12aeba8b4ec2f9.webp";